import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { BlurCont } from 'Layout'
import { SL_GATE } from 'Defaults/modals'
import { SwitchButton } from 'Components/Form'

import {
  _Title, _RoomsTable, _LoginRequired, _ShowMoreCta, _RoomFeaturesTh, _RoomFeaturesTd,
  _SizeHeader,
} from './styles.js'


const convertUnit = (number, convertMode) => {
  if(!number) return ''
  let convertedNumber = convertMode === 'toImp' ?
    parseFloat(number) * 3.28084 : parseFloat(number) / 3.28084
  convertedNumber = Math.round(convertedNumber * 100) / 100
  return convertedNumber.toFixed(1)
}

const Rooms = ({
  rooms,
  unitSystemIsImperial,
  toggleMetric,
  listingIsLocked,
  isCondo,
  noTitle,
  openLogin,
  requiredEmailVerification,
  openEmailVerifyModal,
}) => {
  const showCollapseBtn = rooms && rooms.length > 3
  const [isTableCollapsed, setIsTableCollapsed] = useState(true)

  const onCollapseToggle = () => {
    setIsTableCollapsed(!isTableCollapsed)
  }

  const renderEachRoom = (room, index) => {
    const renderThisRow = !isTableCollapsed || index < 3
    if(renderThisRow) {
      let roomDescriptionsString = ''
      for(let i = 1; i <= 3; i += 1) {
        if(room[`description_${i}`]) roomDescriptionsString += (i > 1 ? ', ' : '') + room[`description_${i}`]
      }

      const dataUnitIsImp = room.unit === 'Feet'
      // check if user select unit and backend data matches don't touch data otherwise convert
      const userUnitMatchesBackend = unitSystemIsImperial === dataUnitIsImp

      const roomLength = userUnitMatchesBackend ?
        room.length : convertUnit(room.length, unitSystemIsImperial ? 'toImp' : 'toMet')
      const roomWidth = userUnitMatchesBackend ?
        room.width : convertUnit(room.width, unitSystemIsImperial ? 'toImp' : 'toMet')


      return (
        <tr key={room.id || room.order}>
          {
            !isCondo &&
              <td>
                <BlurCont blur={listingIsLocked}>{room.level || 'Flat'}</BlurCont>
              </td>
          }
          <td>
            <BlurCont blur={listingIsLocked}>{room.type}</BlurCont>
          </td>
          <td>
            <BlurCont blur={listingIsLocked}>
              {(room.length && room.width) ?
                <div>
                  <span>
                    {roomLength} x {roomWidth} {unitSystemIsImperial ? 'ft' : 'm'}
                  </span>
                </div>
                :
                <span>Unknown</span>
              }
            </BlurCont>
          </td>
          <_RoomFeaturesTd>
            <BlurCont blur={listingIsLocked}>
              {roomDescriptionsString}
            </BlurCont>
          </_RoomFeaturesTd>
        </tr>
      )
    }
    return ''
  }

  if(rooms && rooms.length) {
    return (
      <>
        {
          !noTitle ?
            <_Title>Rooms</_Title>
            : ''
        }

        <_RoomsTable listingIsLocked={listingIsLocked}>
          <thead>
            <tr>
              { !isCondo ? <th>Level</th> : null }
              <th>Name</th>
              <_SizeHeader>
                <span>Size</span>
                <SwitchButton
                  onChange={toggleMetric}
                  isOn={unitSystemIsImperial}
                  onLabel="feet"
                  offLabel="meter"
                  width={72}
                  inputId="sizeSwitch"
                />
              </_SizeHeader>
              <_RoomFeaturesTh>Features</_RoomFeaturesTh>
            </tr>
          </thead>
          <tbody>
            {
              listingIsLocked && (
                <_LoginRequired
                  onClick={
                    requiredEmailVerification ?
                      openEmailVerifyModal :
                      () => openLogin({
                        modalData: { gate: SL_GATE.LISTING_ROOM_INFO },
                      })
                  }
                  primary
                  medium
                >
                  {requiredEmailVerification ? 'Verify your email' : 'Login Required'}
                </_LoginRequired>
              )
            }
            {rooms.map((room, index) => renderEachRoom(room, index))}
          </tbody>
        </_RoomsTable>

        {
          !listingIsLocked && showCollapseBtn ? (
            <_ShowMoreCta
              onClick={onCollapseToggle}
            >
              {isTableCollapsed ? 'Show all' : 'Show less'}
            </_ShowMoreCta>
          ) : ''
        }
      </>
    )
  }

  return null
}

Rooms.propTypes = {
  rooms: PropTypes.arrayOf(PropTypes.shape({})),
  unitSystemIsImperial: PropTypes.bool,
  toggleMetric: PropTypes.func,
  listingIsLocked: PropTypes.bool,
  isCondo: PropTypes.bool,
  noTitle: PropTypes.bool,
  openLogin: PropTypes.func,
  requiredEmailVerification: PropTypes.bool,
  openEmailVerifyModal: PropTypes.func,
}

export default Rooms
